import $ from '@vaersaagod/tools/Dom';
import Viewport from '@vaersaagod/tools/Viewport';
import Dispatch from '@vaersaagod/tools/Dispatch';
import * as Events from '../lib/events';

export default el => {
    const dom = $(el);
    const on = dom.find('[data-on]');
    const off = dom.find('[data-off]');
    const back = dom.find('[data-back]');
    const progress = dom.find('[data-progress]').get(0);
    const audioElement = dom.find('[data-audio]');
    const audio = audioElement.get(0);

    let audioStarted = false;
    let audioLoaded = false;

    const windowHeight = () => (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight || 0);
    const windowScroll = () => (window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop || 0);
    const documentHeight = () => Math.max(
        document.body.scrollHeight || 0,
        document.documentElement.scrollHeight || 0,
        document.body.offsetHeight || 0,
        document.documentElement.offsetHeight || 0,
        document.body.clientHeight || 0,
        document.documentElement.clientHeight || 0
    );

    const update = e => {
        const percent = (windowScroll() / (documentHeight() - windowHeight()));
        TweenLite.to(progress, 0.15, { scaleX: percent, transformOrigin: '0% 0%', ease: Linear.easeNone });
    };

    const loadAudio = () => {
        if (!audioLoaded) {
            audioLoaded = true;
            audio.src = audioElement.data('src');
            audio.volume = 0;
            audio.load();
        }
    };

    const play = () => {
        loadAudio();
        const promise = audio.play();
        if (promise !== undefined) {
            promise.then(() => {
                console.log('play successfull');
                on.addClass('bb-1s bcolor-cc');
                off.removeClass('bb-1s bcolor-cc');
                TweenLite.to(audio, 1, { volume: 1, ease: Linear.easeNone });
            }).catch(error => {
                console.log('play failed', error);
                if (error.name === 'NotAllowedError') {
                    // todo
                } else {
                    // Handle a load or playback error
                }
            });
        }
    };

    const pause = () => {
        off.addClass('bb-1s bcolor-cc');
        on.removeClass('bb-1s bcolor-cc');
        TweenLite.to(audio, 1, { volume: 0, ease: Linear.easeNone, onComplete: () => { audio.pause(); } });
    };

    const userInteraction = () => {
        if (!audioStarted) {
            audioStarted = true;
            play();
            removeUserInteractionEvents();
        }
    };

    const addUserInteractionEvents = () => {
        document.addEventListener('touchstart', userInteraction);
        document.addEventListener('mousedown', userInteraction);
    };

    const removeUserInteractionEvents = () => {
        document.removeEventListener('touchstart', userInteraction);
        document.removeEventListener('mousedown', userInteraction);
    };

    const show = () => {
        TweenLite.to(el, 1.5, { yPercent: '0%', ease: Expo.easeOut });
        TweenLite.to(el, 0.65, { opacity: 1, ease: Cubic.easeInOut });
    };

    const hide = () => {
        TweenLite.to(el, 0.75, { yPercent: '100%', ease: Cubic.easeOut });
        TweenLite.to(el, 0.5, { opacity: 0, ease: Sine.easeOut });
    };

    const init = () => {
        on.on('click', play);
        off.on('click', pause);
        Viewport.on('scroll', update);
        Viewport.on('resize', update);
        Dispatch.on(Events.CONTROLLER_SHOW, show);
        Dispatch.on(Events.CONTROLLER_HIDE, hide);
        TweenLite.set(el, { yPercent: '100%', opacity: 0, display: 'block' });
        addUserInteractionEvents();
    };

    const destroy = () => {
        on.off('click', play);
        off.off('click', pause);
        Viewport.off('scroll', update);
        Viewport.off('resize', update);
        Dispatch.off(Events.CONTROLLER_SHOW, show);
        Dispatch.off(Events.CONTROLLER_HIDE, hide);
        removeUserInteractionEvents();
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/FeaturedController.js